import React from "react";
import styled from "styled-components";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import { ModalHeader, Spacer } from "../MasterCss";
import { ReactComponent as StarsSvg } from "../../assets/stars.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as SpaceOctopus } from "../../assets/space-octopus.svg";

const Container = styled.div`
  background-image: linear-gradient(#060606, #08345c);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  height: 100vh;
  width: 100vw;
  z-index: -10;
`;

const Octopus = styled(SpaceOctopus)`
  position: absolute;
  top: 12vh;
  right: 10vw;
`;

const Stars = styled(StarsSvg)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  overflow: hidden;
  z-index: 0;
`;

const Error = props => {
  const navigate = useNavigate();
  const { t } = useTranslation(); 
  const goHome = () => {
    navigate("/");
  };

  return (
    <Container>
      <Spacer/>
      <Spacer/>
      <Spacer/>
      <Spacer/>
      <Spacer/>
      <Spacer/>
      <Spacer/>
      <ModalHeader>{t('error.title')}</ModalHeader>
    
      <ModalHeader>{t('error.subtitle')}</ModalHeader>
      <Spacer/>
      <Octopus />
      <Stars />
      <Button primary handleClick={goHome} label={t('error.button')} />
    </Container>
  );
};

export default Error;
